module.exports = __webpack_public_path__ + "img/cancel_order.8690dcf2.svg";